var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,5.25 L18,3 L18,9 L15,6.75 L15,8 C15,8.55228475 14.5522847,9 14,9 L8,9 C7.44771525,9 7,8.55228475 7,8 L7,4 C7,3.44771525 7.44771525,3 8,3 L14,3 Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16,10.5857864 L17.4142136,12 L13.4137864,15.9997864 L17.4142136,20 L16,21.4142136 L11.9997864,17.4137864 L8,21.4142136 L6.58578644,20 L10.5857864,15.9997864 L6.58578644,12 L8,10.5857864 L11.9997864,14.5857864 L16,10.5857864 Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }